import { AdminPageHeader } from '@/components/patterns/admin-page'
import UserForm from '@/components/forms/UserForm'
import IfGlobalOrg from '@/components/organizations/IfGlobalOrg'
import { OrganizationContextNotice } from '@/components/patterns/info-notice'
import { organizationQueries } from '@/lib/services/organizations/organizations.query'
import { roleQueries } from '@/lib/services/roles/roles.query'
import {
  canAssignUserRoles,
  canCreateUsersInOrganization,
  canViewRolePermissions,
} from '@/lib/user-access'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { UserPlus } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/$orgId/users/create')({
  loader: async ({ context, params }) => {
    const organization = await context.queryClient.ensureQueryData(
      organizationQueries.show(params.orgId)
    )

    if (!canCreateUsersInOrganization(context.ability, organization)) throw notFound()

    if (canAssignUserRoles(context.ability) || canViewRolePermissions(context.ability)) {
      void context.queryClient.ensureQueryData(roleQueries.index({ organizationId: params.orgId }))
    }

    return { isReadOnly: false }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="max-w-5xl space-y-4">
      <AdminPageHeader icon={UserPlus} title="Create User" />
      <IfGlobalOrg>
        <OrganizationContextNotice>
          You are currently creating a OneStem global user.
        </OrganizationContextNotice>
      </IfGlobalOrg>
      <UserForm />
    </div>
  )
}
